/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './details.tpl.html';

angular
  .module('mobile.batch.details', [])
  /**
   * Controller for the mobile batch.details template.
   */
  .controller('MobileBatchDetailsCtrl', function ($scope, $filter, batchInfo, httpBatch, TYPES, BACKUP_STATE) {
    // array to hold all types for easy access when all are selected.
    var allTypes = [],
      typesObj = {};

    // array to hold valid types for display.
    $scope.types = [];
    // constant for type related data.
    $scope.TYPES = TYPES;

    /**
     * Utility to refresh the detail view.
     */
    function refreshDetails() {
      // reset these vars on refresh
      allTypes = [];
      typesObj = {};

      // If there is a batchUtils.currentBatch save off the max total as the divider in the percent
      // width calculation for the progress bars.
      if ($scope.batchUtils.currentBatch && !$scope.batchUtils.currentBatch.noBackup) {
        $scope.noBackup = false;
        $scope.divider = _.max($scope.batchUtils.currentBatch.typeCounts, function (obj) {
          return obj.total;
        }).total;

        // filter out any types that have a zero count and that have their metadata flag set to true.
        _.each($scope.batchUtils.currentBatch.typeCounts, function (counts, type) {
          if (counts.total && counts.total !== 0 && !counts.md) {
            typesObj[type] = _.clone(counts);
            // save the name as part of the object
            typesObj[type].name = type;
            allTypes.push(type);
          }
        });
        // Now order by total
        $scope.types = _.sortBy(typesObj, function (obj) {
          // negative b/c I want ASC
          return -obj.total;
        });
      } else {
        $scope.noBackup = true;
      }
    }

    /**
     * Returns the comma separated value for the number
     *
     * @param {number} num - The number to apply the filter to.
     * @return {string} The number with commas applied.
     */
    $scope.getNum = function (num) {
      return $filter('number')(num);
    };

    refreshDetails();

    // Watches to resize the canvas app based on the current state of the backup.
    $scope.$watch('backupInProgress ', function () {
      if (!$scope.backupInProgress && $scope.batchUtils.currentBatch.state !== BACKUP_STATE.FINISHED) {
        // if the original backupStatus was not Finished then load the batch.
        $scope.batchUtils.loadBatch($scope.stateParams.batchId).then(function () {
          refreshDetails();
        });
      }
    });
  });
